/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Microsoft_Tenant_HintInputs */



/**
* | output |
* | --- |
* | "Find it in the Microsoft Entra admin center under Overview. Check it carefully: members signing in with Microsoft from any other tenant, and personal Microso..." |
*
* @param {Microsoft_Tenant_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const microsoft_tenant_hint = /** @type {((inputs?: Microsoft_Tenant_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Microsoft_Tenant_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie finden sie im Microsoft Entra Admin Center unter Übersicht. Prüfen Sie sie sorgfältig: Mitglieder, die sich mit Microsoft aus einem anderen Mandanten anmelden, und persönliche Microsoft-Konten kommen danach nicht mehr hinein. Passkeys und die Anmeldung per E-Mail sind nicht betroffen.")
	return /** @type {LocalizedString} */ ("Find it in the Microsoft Entra admin center under Overview. Check it carefully: members signing in with Microsoft from any other tenant, and personal Microsoft accounts, will no longer get in. Passkeys and email sign-in are not affected.")
});